import { render, staticRenderFns } from "./GroupResults.vue?vue&type=template&id=d80c9072"
import script from "./GroupResults.vue?vue&type=script&lang=ts"
export * from "./GroupResults.vue?vue&type=script&lang=ts"
import style0 from "./GroupResults.vue?vue&type=style&index=0&id=d80c9072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports